import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import store from '@/store'
import router from '../router'
import md5 from 'js-md5'
import Cookies from 'js-cookie'
const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',
    timeout: 5000
})
service.interceptors.request.use(
    config => {
		let url=config.url
		//过滤接口
		console.log(router)
		if(url.split('/').pop()=='getOssToken'){
			return config
		}
		console.log(store.getters.token)
        if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = getToken()
        }
		// if(config.method=='post'){ 
		// 	config.data = { 
		// 		_t: Date.parse(new Date())/1000
		// 	} 
		// }else if(config.method=='get'){ 
		// 	config.params = { 
		// 		_t: Date.parse(new Date())/1000
		// 	} 
		// } 
		// 拦截器加密---------------------------------------------------------------------------------------
		//符号过滤   (/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,'')
		let newData = ''
		let condata=config.data||config.params
		if (condata) {
			// 排序--循环拼接转为get参数形式
			Object.keys(condata).sort().forEach(function(key) {
				if (typeof condata[key] != 'undefined') { //将undefined过滤
					if (newData == '') {
						if(Array.prototype.isPrototypeOf(condata[key])){
							if(Object.prototype.toString.call(condata[key][0]) === '[object Object]'){
								newData += key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
								return false
							}
						}
						if(Object.prototype.toString.call(condata[key]) === '[object Object]'){
							newData += key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
							return false
						}
						newData += key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
					} else {
						if(Array.prototype.isPrototypeOf(condata[key])){
							if(Object.prototype.toString.call(condata[key][0]) === '[object Object]'){
								newData +='&' + key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
								return false
							}
						}
						if(Object.prototype.toString.call(condata[key]) === '[object Object]'){
							newData +='&' + key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
							return false
						}
						newData += '&' + key + '=' + String(decodeURIComponent(condata[key])).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
					}
				}
			});
			// config.headers['randomUidRes'] = encodeURIComponent(JSON.stringify(config.data));
		} else if (config.url.indexOf('?') != -1) {//判断是不是以？传参 get传参方式 如果是也处理
			const params = config.url.slice(config.url.indexOf('?') + 1, config.url.length); // 切割？后以后的数据
			// console.log(params);
			const newParams = params.split("&");
			// console.log(newParams);
			const urlObj = new Object();
			for (let i = 0; i < newParams.length; i++) {
				const newArray = newParams[i].split('=');
				// console.log(newArray);
				urlObj[newArray[0]] = newArray[1]
			}
			// 排序--循环拼接转为get参数形式
			Object.keys(urlObj).sort().forEach(function(key) {
				if (typeof urlObj[key] != 'undefined') { //将undefined过滤
					if (newData == '') {
						if(Array.prototype.isPrototypeOf(urlObj[key])){
							if(Object.prototype.toString.call(urlObj[key][0]) === '[object Object]'){
								newData += key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
								return false
							}
						}
						if(Object.prototype.toString.call(urlObj[key]) === '[object Object]'){
							newData += key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
							return false
						}
						newData += key + '=' + String(decodeURIComponent(urlObj[key])).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
					} else {
						if(Array.prototype.isPrototypeOf(urlObj[key])){
							if(Object.prototype.toString.call(urlObj[key][0]) === '[object Object]'){
								newData +='&' + key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
								return false
							}
						}
						if(Object.prototype.toString.call(urlObj[key]) === '[object Object]'){
							newData +='&' + key + '=' + String(decodeURIComponent(JSON.stringify(condata[key]))).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
							return false
						}
						newData += '&' + key + '=' + String(decodeURIComponent(urlObj[key])).replace(/[`~!@#$%^&*()_\-+=\n<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}\s《》？：“”【】、；‘’，。、]/g, '')
					}
				}
			});
			// config.headers['randomUidRes'] = encodeURIComponent(JSON.stringify(urlObj));
		}
		// 如果符合以上两种传参并不为空 拼接加密
		if (config.url.indexOf('?') != -1 || condata) {
			// 拼接并加密
			let pass =
				'K%jYh*2SkPb!t!AmGcnM#@dI^Hik3Oo1FF#Oir&7Lb773Op^5yZSnei@JakKt8g&!5cD8@DYFnVPnXox8%4G$45HY6u$0QbujeP' +
				'&' + escape(newData) + '&' +
				'K%jYh*2SkPb!t!AmGcnM#@dI^Hik3Oo1FF#Oir&7Lb773Op^5yZSnei@JakKt8g&!5cD8@DYFnVPnXox8%4G$45HY6u$0QbujeP'
				// console.log(pass)
			let md5pass=md5(pass)//md5加密
			let newmd5pass=''
			//翻转md5加密后的结果
			for(let i=0;i<md5pass.length;i++){
				let s=md5pass.charAt(md5pass.length-i-1)
				newmd5pass+=s
			}
			//放到请求头里面
			config.headers['randomUid'] = newmd5pass;
		}
		// 拦截器加密---------------------------------------------------------------------------------------
        return config
    },
    error => {
        // console.log(error)
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
    }
)
service.interceptors.response.use(
    // response => {
    //     if (response.status === 200) {
    //         return response.data
    //     } else {
    //         // eslint-disable-next-line prefer-promise-reject-errors
    //         Promise.reject()
    //     }
    // },
    // error => {
    //     console.log(error)
    //     // eslint-disable-next-line prefer-promise-reject-errors
    //     return Promise.reject()
    // }
    response => {
			const res = response.data
			// if the custom code is not 20000, it is judged as an error.
			if (res.status && res.status !== 200 && res.status !== '200') {
				if(!Cookies.get('flag')){
					Message({
						message: res.msg || 'Error',
						type: 'error',
						duration: 5 * 1000
					})
				}
			    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
			    if (res.code === 2000 || res.code === '2000') {
			        // to re-login
					if(Cookies.get('flag')){//单点登录判断
						Cookies.remove('flag')
						window.location.reload()
					}else{
						MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
						    confirmButtonText: '重新登录',
						    cancelButtonText: '取消',
						    type: 'warning'
						}).then(() => {
						    removeToken()
						    location.reload()
						})
					}
			        
			    }
			    return Promise.reject(res)
			} else {
			    return res
			}
    },
    error => {
        // Message({
        //     message: error.msg || '系统异常！',
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js